import Styled from 'styled-components';
import { respondTo } from '@/respondTo';

export const CardContainer = Styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center; 
    padding:0.625rem 0; 
    max-width: 31.89rem;

   ${respondTo.tablet_landscape_s`
    
    padding:0 1.25rem;
    `}

  
 
`;
export const ImgBox = Styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background-color:var(--on-surface-dark) !important;
    padding:1.68rem;
    `;

    export const CustomImg = Styled.div`
    position: relative;
    width: 80px;
    height: 80px;

    ${respondTo.desktop`
    width: 100px;
    height: 100px;
    `}
    `;


export const CardTitle = Styled.h1 <{selecteditem?:number}>`
    color :  var(--background-light);
    transition: color 0.3s ease-in-out;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1.25rem 0 0.625rem;

    ${respondTo.desktop`
    padding: 2.5rem 0 0.625rem;
    `}

    ${respondTo.desktop_xl`
    padding: 2.5rem 0 0.625rem;
    `}
`;

export const CardDescription = Styled.p  <{selecteditem?:number}>`
display: block;
color:  var(--on-surface-dark) ;
transition: color 0.3s ease-in-out;
text-align: left;

`;

